// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"index__imgBox__xNohK","imgContainer":"index__imgContainer__BDaq9"};